// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C13: buyer issued and adjusted detail, isolated from preparation and public PDFs. */
.rcti-issued-journey {
  padding: var(--space-8);
}
.rcti-issued-journey .rcti-detail-back {
  margin-bottom: var(--space-8);
  color: var(--interactive-default);
}
.rcti-issued-journey .rcti-detail-header {
  margin-bottom: var(--space-6);
}
.rcti-issued-journey .rcti-detail-header p {
  margin-top: var(--space-2);
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-issued-journey .rcti-detail-context {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  border: 0;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  color: var(--success-text);
  margin-block: var(--space-6);
}
.rcti-issued-journey .rcti-detail-context > svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.rcti-issued-journey .rcti-detail-context > div {
  display: grid;
  gap: var(--space-2);
}
.rcti-issued-journey .rcti-detail-context > div > span {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-issued-journey .rcti-issued-toolbar {
  margin-bottom: var(--space-6);
}
.rcti-issued-journey .rcti-detail-layout {
  grid-template-columns: minmax(0, 1fr) 368px;
  gap: var(--space-6);
}
.rcti-issued-journey
  :is(.rcti-detail-document, .rcti-detail-state-card, .rcti-detail-aside
    .invoice-flow-card) {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: none;
  padding: var(--space-6);
}
.rcti-issued-journey .rcti-detail-aside {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
.rcti-issued-journey .rcti-balance-card > div {
  display: block;
}
.rcti-issued-journey .rcti-balance-card > div > svg {
  display: none;
}
.rcti-issued-journey .rcti-balance-card h2 {
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-issued-journey .rcti-balance-card > .rcti-type-emphasis {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-h2);
  line-height: 1.4;
  margin-block: var(--space-4);
}
.rcti-issued-journey .rcti-balance-card > p {
  margin: 0;
}
.rcti-c13-balances {
  display: grid;
  gap: var(--space-4);
  margin: var(--space-6) 0 var(--space-4);
}
.rcti-c13-balances > div {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--space-3);
  font-size: var(--font-size-body-sm);
}
.rcti-c13-balances dt {
  color: var(--text-secondary);
}
.rcti-c13-balances dd {
  margin: 0;
  font-family: var(--font-family-mono);
  white-space: nowrap;
}
.rcti-c13-outstanding {
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-4);
  font-weight: var(--font-weight-medium);
}
.rcti-c13-document-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5) var(--space-6);
}
.rcti-c13-document-meta > div {
  display: grid;
  align-content: start;
  gap: var(--space-2);
  min-width: 0;
}
.rcti-c13-document-meta span,
.rcti-c13-notes > span {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.rcti-c13-document-meta strong {
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-regular);
  overflow-wrap: anywhere;
}
.rcti-issued-journey .rcti-paper-business > span {
  color: var(--interactive-default);
}
.rcti-issued-journey .rcti-paper-parties :is(strong, small) {
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-regular);
  line-height: 1.55;
  overflow-wrap: anywhere;
}
.rcti-issued-journey .rcti-document-table {
  font-size: var(--font-size-body-sm);
  min-width: 560px;
}
.rcti-issued-journey .rcti-document-table th {
  background: var(--surface-secondary);
  font-size: var(--font-size-caption-md);
  border-bottom: 0;
}
.rcti-issued-journey .rcti-document-table :is(th, td) {
  padding: var(--space-4) var(--space-3);
}
.rcti-issued-journey .rcti-document-table td strong {
  font-weight: var(--font-weight-regular);
}
.rcti-issued-journey .rcti-document-table td:not(:first-child) {
  font-family: var(--font-family-mono);
}
.rcti-issued-journey .rcti-detail-summary > div:first-child {
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-4);
}
.rcti-issued-journey .rcti-detail-summary {
  padding-top: 0;
}
.rcti-c13-legal-lock {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
  color: var(--text-secondary);
  padding: var(--space-3);
}
.rcti-c13-legal-lock > svg {
  flex-shrink: 0;
  margin-top: 3px;
}
.rcti-c13-legal-lock > p {
  margin: 0;
}
.rcti-issued-history {
  padding: 0;
  margin: var(--space-5) 0 0;
  list-style: none;
}
.rcti-issued-history li + li {
  border-top: 1px solid var(--border-subtle);
  margin-top: var(--space-6);
  padding-top: var(--space-6);
}
.rcti-issued-history li > div {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
}
.rcti-issued-history time {
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.rcti-issued-history p {
  margin: var(--space-2) 0 var(--space-4);
}
.rcti-issued-history li > div > strong {
  font-family: var(--font-family-mono);
}
.rcti-issued-journey .rcti-detail-action,
.rcti-issued-journey .rcti-issued-footer > a {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: var(--space-2);
  min-height: 40px;
  padding: var(--space-3);
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  text-decoration: none;
  font-size: var(--font-size-body-sm);
  cursor: pointer;
}
.rcti-issued-journey .rcti-detail-action.primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-color: var(--interactive-default);
}
.rcti-issued-journey button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.rcti-c13-text-action {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--interactive-default);
  font: inherit;
  font-size: var(--font-size-caption-md);
  cursor: pointer;
  text-align: left;
}
.rcti-c13-agreement-ref {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  flex-wrap: wrap;
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.rcti-c13-agreement-ref .rcti-status {
  text-transform: capitalize;
}
.rcti-issued-journey .rcti-issued-footer {
  border: 0;
}
.rcti-issued-adjustment-card {
  order: 6;
}
@media (max-width: 1250px) {
  .rcti-issued-journey .rcti-detail-layout {
    grid-template-columns: minmax(0, 1fr) 320px;
  }
}
@media (max-width: 1050px) {
  .rcti-issued-journey {
    padding: var(--space-6);
  }
  .rcti-issued-journey .rcti-detail-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-issued-journey .rcti-detail-aside {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}
@media (max-width: 600px) {
  .rcti-issued-journey {
    padding: var(--space-4);
  }
  .rcti-issued-journey .rcti-detail-aside,
  .rcti-c13-document-meta {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-issued-journey
    :is(.rcti-detail-document, .rcti-detail-state-card, .rcti-detail-aside
      .invoice-flow-card) {
    padding: var(--space-4);
  }
  .rcti-issued-journey .rcti-issued-toolbar > div {
    width: 100%;
  }
  .rcti-issued-journey .invoice-editor-actions > button {
    flex: 1 1 auto;
  }
}

.rcti-issued-journey .rcti-balance-card > p {
  padding-bottom: 0;
}
.rcti-issued-journey .rcti-detail-document > hr {
  margin: 0;
}
.rcti-issued-journey .rcti-paper-identity h2 {
  font-weight: var(--font-weight-semibold);
  margin: 0;
}
.rcti-issued-journey .rcti-paper-parties {
  padding-bottom: 0;
  border: 0;
}
.rcti-issued-journey .rcti-detail-summary > div:last-child .grand {
  background: transparent;
  padding-inline: 0;
  border: 0;
  border-radius: 0;
}
.rcti-issued-journey
  .rcti-detail-summary
  > div:last-child
  .grand
  .rcti-type-emphasis {
  font-size: var(--font-size-body-lg);
}
.rcti-issued-journey .rcti-detail-aside > section {
  order: 0;
}
.rcti-issued-journey .rcti-detail-aside > .rcti-issued-adjustment-card {
  order: 1;
}
.rcti-issued-journey .rcti-detail-aside .rcti-status {
  align-self: flex-start;
}
.rcti-issued-journey .rcti-detail-aside .rcti-detail-action {
  align-self: flex-start;
  width: auto;
}
.rcti-issued-journey .rcti-detail-aside > section > p {
  margin-block: var(--space-3);
}
.rcti-issued-journey .rcti-detail-state-card > a:not(.rcti-detail-action) {
  font-size: var(--font-size-body-sm);
}
.rcti-issued-journey .rcti-status.status-unpaid {
  color: var(--warning-text);
  background: var(--warning-soft);
}
.rcti-issued-journey .rcti-detail-context {
  color: var(--success-text);
  background: var(--success-soft);
}
.rcti-c13-original-summary {
  width: min(100%, 360px);
  margin: 0 0 0 auto;
  display: grid;
  gap: var(--space-3);
}
.rcti-c13-original-summary > div {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
  font-size: var(--font-size-body-sm);
}
.rcti-c13-original-summary dt {
  color: var(--text-secondary);
}
.rcti-c13-original-summary dd {
  margin: 0;
  font-family: var(--font-family-mono);
}
.rcti-c13-original-summary > div:last-child {
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-3);
  font-weight: var(--font-weight-medium);
}
/* Avoid legacy editor flex spacing inside the compact C13 summary cards. */
.rcti-issued-journey .rcti-detail-aside > section { display: block; }
.rcti-issued-journey .rcti-detail-aside > section > h2 { margin: 0 0 var(--space-4); font-weight: var(--font-weight-medium); }
.rcti-issued-journey .rcti-balance-card > .rcti-type-emphasis { display: block; }
.rcti-issued-journey .rcti-detail-document { color: var(--text-primary); }
.rcti-issued-journey .rcti-paper-parties :is(strong,small) { color: var(--text-primary); }
.rcti-issued-journey .rcti-detail-aside > section > p { color: var(--text-primary); }
.rcti-issued-journey .rcti-balance-card > p { color: var(--text-secondary); }
.rcti-issued-journey .rcti-delivery-card .rcti-c13-text-action { display: block; margin-top: var(--space-3); }
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiIssuedDetail.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;;;EAGE,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,2CAA2C;EAC7C;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;;IAEE,qCAAqC;EACvC;EACA;;;IAGE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,wCAAwC;EACxC,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;AACA;;;;;EAKE,mCAAmC;AACrC;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,sCAAsC;AACxC;AACA,2EAA2E;AAC3E,oDAAoD,cAAc,EAAE;AACpE,yDAAyD,0BAA0B,EAAE,sCAAsC,EAAE;AAC7H,gEAAgE,cAAc,EAAE;AAChF,6CAA6C,0BAA0B,EAAE;AACzE,6DAA6D,0BAA0B,EAAE;AACzF,wDAAwD,0BAA0B,EAAE;AACpF,8CAA8C,4BAA4B,EAAE;AAC5E,iEAAiE,cAAc,EAAE,0BAA0B,EAAE","sourcesContent":["/* C13: buyer issued and adjusted detail, isolated from preparation and public PDFs. */\n.rcti-issued-journey {\n  padding: var(--space-8);\n}\n.rcti-issued-journey .rcti-detail-back {\n  margin-bottom: var(--space-8);\n  color: var(--interactive-default);\n}\n.rcti-issued-journey .rcti-detail-header {\n  margin-bottom: var(--space-6);\n}\n.rcti-issued-journey .rcti-detail-header p {\n  margin-top: var(--space-2);\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-issued-journey .rcti-detail-context {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  border: 0;\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  color: var(--success-text);\n  margin-block: var(--space-6);\n}\n.rcti-issued-journey .rcti-detail-context > svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n.rcti-issued-journey .rcti-detail-context > div {\n  display: grid;\n  gap: var(--space-2);\n}\n.rcti-issued-journey .rcti-detail-context > div > span {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-issued-journey .rcti-issued-toolbar {\n  margin-bottom: var(--space-6);\n}\n.rcti-issued-journey .rcti-detail-layout {\n  grid-template-columns: minmax(0, 1fr) 368px;\n  gap: var(--space-6);\n}\n.rcti-issued-journey\n  :is(.rcti-detail-document, .rcti-detail-state-card, .rcti-detail-aside\n    .invoice-flow-card) {\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  box-shadow: none;\n  padding: var(--space-6);\n}\n.rcti-issued-journey .rcti-detail-aside {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n.rcti-issued-journey .rcti-balance-card > div {\n  display: block;\n}\n.rcti-issued-journey .rcti-balance-card > div > svg {\n  display: none;\n}\n.rcti-issued-journey .rcti-balance-card h2 {\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-issued-journey .rcti-balance-card > .rcti-type-emphasis {\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-h2);\n  line-height: 1.4;\n  margin-block: var(--space-4);\n}\n.rcti-issued-journey .rcti-balance-card > p {\n  margin: 0;\n}\n.rcti-c13-balances {\n  display: grid;\n  gap: var(--space-4);\n  margin: var(--space-6) 0 var(--space-4);\n}\n.rcti-c13-balances > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--space-3);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c13-balances dt {\n  color: var(--text-secondary);\n}\n.rcti-c13-balances dd {\n  margin: 0;\n  font-family: var(--font-family-mono);\n  white-space: nowrap;\n}\n.rcti-c13-outstanding {\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-4);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-c13-document-meta {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5) var(--space-6);\n}\n.rcti-c13-document-meta > div {\n  display: grid;\n  align-content: start;\n  gap: var(--space-2);\n  min-width: 0;\n}\n.rcti-c13-document-meta span,\n.rcti-c13-notes > span {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-c13-document-meta strong {\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-regular);\n  overflow-wrap: anywhere;\n}\n.rcti-issued-journey .rcti-paper-business > span {\n  color: var(--interactive-default);\n}\n.rcti-issued-journey .rcti-paper-parties :is(strong, small) {\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.55;\n  overflow-wrap: anywhere;\n}\n.rcti-issued-journey .rcti-document-table {\n  font-size: var(--font-size-body-sm);\n  min-width: 560px;\n}\n.rcti-issued-journey .rcti-document-table th {\n  background: var(--surface-secondary);\n  font-size: var(--font-size-caption-md);\n  border-bottom: 0;\n}\n.rcti-issued-journey .rcti-document-table :is(th, td) {\n  padding: var(--space-4) var(--space-3);\n}\n.rcti-issued-journey .rcti-document-table td strong {\n  font-weight: var(--font-weight-regular);\n}\n.rcti-issued-journey .rcti-document-table td:not(:first-child) {\n  font-family: var(--font-family-mono);\n}\n.rcti-issued-journey .rcti-detail-summary > div:first-child {\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-4);\n}\n.rcti-issued-journey .rcti-detail-summary {\n  padding-top: 0;\n}\n.rcti-c13-legal-lock {\n  display: flex;\n  gap: var(--space-2);\n  align-items: flex-start;\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n  padding: var(--space-3);\n}\n.rcti-c13-legal-lock > svg {\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n.rcti-c13-legal-lock > p {\n  margin: 0;\n}\n.rcti-issued-history {\n  padding: 0;\n  margin: var(--space-5) 0 0;\n  list-style: none;\n}\n.rcti-issued-history li + li {\n  border-top: 1px solid var(--border-subtle);\n  margin-top: var(--space-6);\n  padding-top: var(--space-6);\n}\n.rcti-issued-history li > div {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-3);\n}\n.rcti-issued-history time {\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.rcti-issued-history p {\n  margin: var(--space-2) 0 var(--space-4);\n}\n.rcti-issued-history li > div > strong {\n  font-family: var(--font-family-mono);\n}\n.rcti-issued-journey .rcti-detail-action,\n.rcti-issued-journey .rcti-issued-footer > a {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-2);\n  min-height: 40px;\n  padding: var(--space-3);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  text-decoration: none;\n  font-size: var(--font-size-body-sm);\n  cursor: pointer;\n}\n.rcti-issued-journey .rcti-detail-action.primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-color: var(--interactive-default);\n}\n.rcti-issued-journey button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rcti-c13-text-action {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default);\n  font: inherit;\n  font-size: var(--font-size-caption-md);\n  cursor: pointer;\n  text-align: left;\n}\n.rcti-c13-agreement-ref {\n  display: flex;\n  gap: var(--space-2);\n  align-items: center;\n  flex-wrap: wrap;\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c13-agreement-ref .rcti-status {\n  text-transform: capitalize;\n}\n.rcti-issued-journey .rcti-issued-footer {\n  border: 0;\n}\n.rcti-issued-adjustment-card {\n  order: 6;\n}\n@media (max-width: 1250px) {\n  .rcti-issued-journey .rcti-detail-layout {\n    grid-template-columns: minmax(0, 1fr) 320px;\n  }\n}\n@media (max-width: 1050px) {\n  .rcti-issued-journey {\n    padding: var(--space-6);\n  }\n  .rcti-issued-journey .rcti-detail-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-issued-journey .rcti-detail-aside {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-issued-journey {\n    padding: var(--space-4);\n  }\n  .rcti-issued-journey .rcti-detail-aside,\n  .rcti-c13-document-meta {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-issued-journey\n    :is(.rcti-detail-document, .rcti-detail-state-card, .rcti-detail-aside\n      .invoice-flow-card) {\n    padding: var(--space-4);\n  }\n  .rcti-issued-journey .rcti-issued-toolbar > div {\n    width: 100%;\n  }\n  .rcti-issued-journey .invoice-editor-actions > button {\n    flex: 1 1 auto;\n  }\n}\n\n.rcti-issued-journey .rcti-balance-card > p {\n  padding-bottom: 0;\n}\n.rcti-issued-journey .rcti-detail-document > hr {\n  margin: 0;\n}\n.rcti-issued-journey .rcti-paper-identity h2 {\n  font-weight: var(--font-weight-semibold);\n  margin: 0;\n}\n.rcti-issued-journey .rcti-paper-parties {\n  padding-bottom: 0;\n  border: 0;\n}\n.rcti-issued-journey .rcti-detail-summary > div:last-child .grand {\n  background: transparent;\n  padding-inline: 0;\n  border: 0;\n  border-radius: 0;\n}\n.rcti-issued-journey\n  .rcti-detail-summary\n  > div:last-child\n  .grand\n  .rcti-type-emphasis {\n  font-size: var(--font-size-body-lg);\n}\n.rcti-issued-journey .rcti-detail-aside > section {\n  order: 0;\n}\n.rcti-issued-journey .rcti-detail-aside > .rcti-issued-adjustment-card {\n  order: 1;\n}\n.rcti-issued-journey .rcti-detail-aside .rcti-status {\n  align-self: flex-start;\n}\n.rcti-issued-journey .rcti-detail-aside .rcti-detail-action {\n  align-self: flex-start;\n  width: auto;\n}\n.rcti-issued-journey .rcti-detail-aside > section > p {\n  margin-block: var(--space-3);\n}\n.rcti-issued-journey .rcti-detail-state-card > a:not(.rcti-detail-action) {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-issued-journey .rcti-status.status-unpaid {\n  color: var(--warning-text);\n  background: var(--warning-soft);\n}\n.rcti-issued-journey .rcti-detail-context {\n  color: var(--success-text);\n  background: var(--success-soft);\n}\n.rcti-c13-original-summary {\n  width: min(100%, 360px);\n  margin: 0 0 0 auto;\n  display: grid;\n  gap: var(--space-3);\n}\n.rcti-c13-original-summary > div {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-3);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c13-original-summary dt {\n  color: var(--text-secondary);\n}\n.rcti-c13-original-summary dd {\n  margin: 0;\n  font-family: var(--font-family-mono);\n}\n.rcti-c13-original-summary > div:last-child {\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-3);\n  font-weight: var(--font-weight-medium);\n}\n/* Avoid legacy editor flex spacing inside the compact C13 summary cards. */\n.rcti-issued-journey .rcti-detail-aside > section { display: block; }\n.rcti-issued-journey .rcti-detail-aside > section > h2 { margin: 0 0 var(--space-4); font-weight: var(--font-weight-medium); }\n.rcti-issued-journey .rcti-balance-card > .rcti-type-emphasis { display: block; }\n.rcti-issued-journey .rcti-detail-document { color: var(--text-primary); }\n.rcti-issued-journey .rcti-paper-parties :is(strong,small) { color: var(--text-primary); }\n.rcti-issued-journey .rcti-detail-aside > section > p { color: var(--text-primary); }\n.rcti-issued-journey .rcti-balance-card > p { color: var(--text-secondary); }\n.rcti-issued-journey .rcti-delivery-card .rcti-c13-text-action { display: block; margin-top: var(--space-3); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
